// TEXT

// STYLES

// DATA

// TYPES
export type LoaderData = {
  forwardIfAuthenticated: Promise<void>;
};

// CONSTANTS
export const FORWARD_AUTH_LAYOUT_ID = "forward-auth-layout";

// FUNCTIONS

// ASSETS
